import { RootObject, IContet } from '../../type';

import './style.less';

const EasyDeployDescribe = (props: RootObject["easyDeployDescribe"]) => {
    const { easyDeployDescribeTitle, content, description } = props;

    const onJump = (data: IContet) => {
        if (data.jumpLink) {
            window.open(data.jumpLink, '_blank')
        }
    }

    return (
        <div className="easy-deploy-describe">
            <div className="easy-deploy-describe-title">
                {easyDeployDescribeTitle}
            </div>
            <div className="easy-deploy-describe-desc">
                {description ?? ''}
            </div>
            <div className='easy-deploy-describe-item-wrapper'>
                {
                    content.map(item => (
                        <div
                            key={item.title}
                            onClick={() => onJump(item)}
                            className='easy-deploy-describe-item'>
                            <div
                                style={{ backgroundImage: `url(${item.icon})` }}
                                className='easy-deploy-describe-item-icon' />
                            <div className='easy-deploy-describe-item-title'>
                                {item.title}
                            </div>
                            <div className='easy-deploy-describe-item-desc'>
                                {item.desc}
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default EasyDeployDescribe;